module.exports = __webpack_public_path__ + "img/xlsx.77a28f01.svg";